import axios from 'axios';

export const getBackendUrl = () => {
  let url = process.env.REACT_APP_API_URL;
  if (url) {
    url = url.trim().replace(/\/$/, '');
    if (url.endsWith('/api')) url = url.substring(0, url.length - 4);
    return url;
  }
  if (process.env.NODE_ENV === 'production') {
    console.error('REACT_APP_API_URL is not set. API calls will fail. Set it in your Render dashboard.');
  }
  return 'http://localhost:5000';
};

export const BACKEND_URL = getBackendUrl();

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Automatically clear session and redirect to login on 401 (expired/invalid token)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        setTimeout(() => { window.location.href = '/login'; }, 0);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
